<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead"><span><a id="auto_bookmark_table_of_contents_1"></a>Acknowledgments</span></p>
<p class="P_WFP_BodyText">Our special thanks go to Kevin J. Anderson, Rebecca Moesta, Peter J. Wacks, Jessyca Hogue, Keith J. Olexa, Quincy Allen, and Diane Jones of WordFire Press, and our agent John Silbersack.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0005.vue?32eb2fc0